module.exports = __webpack_public_path__ + "components/rewards/isobaa/static/logo-12fac8fcb7fc26befd26f63ba25de8e3.jpg";